import userPrincipal from './store/userPrincipal/reducer';

const reducers = {
    userPrincipal: userPrincipal,
};

export default reducers;
